import React from 'react';
import PropTypes from 'prop-types';

import HtmlElement from '../HtmlElement';

const defaultProps = {
  children: null,
};

const propTypes = {
  children: PropTypes.node,
};

const Text = ({
  children,
  ...rest
}) => (
  <HtmlElement
    tagName="p"
    {...rest}
  >
    {children}
  </HtmlElement>
);

Text.defaultProps = defaultProps;
Text.propTypes = propTypes;

export default Text;
